import React, { useState, useEffect } from 'react';
import { 
  Lock, RotateCcw, Truck, Headphones, Zap, Leaf, Heart, 
  Shield, Smile, Award, Gift, CheckCircle, Star, ThumbsUp 
} from 'lucide-react';
import { API_URL } from '../config';
import './BottomFeatures.css';



const IconMap = {
  Lock,
  RotateCcw,
  Truck,
  Headphones,
  Zap,
  Leaf,
  Heart,
  Shield,
  Smile,
  Award,
  Gift,
  CheckCircle,
  Star,
  ThumbsUp
};

const defaultFeatures = [
  {
    icon: "Lock",
    title: "Secure Payments",
    subtitle: "100% Protected Transactions"
  },
  {
    icon: "RotateCcw",
    title: "Easy Returns",
    subtitle: "7-Day Hassle-Free Returns"
  },
  {
    icon: "Truck",
    title: "Fast Delivery",
    subtitle: "Direct to Your Doorstep"
  },
  {
    icon: "Headphones",
    title: "Customer Support",
    subtitle: "24/7 Dedicated Assistance"
  }
];

const BottomFeatures = () => {
  const [features, setFeatures] = useState(defaultFeatures);

  useEffect(() => {
    fetch(`${API_URL}/settings/bottom_features`)
      .then((res) => {
        if (!res.ok) throw new Error('Failed to load bottom features settings');
        return res.json();
      })
      .then((data) => {
        if (Array.isArray(data) && data.length > 0) {
          setFeatures(data);
        }
      })
      .catch((err) => console.error('Error fetching bottom features settings:', err));
  }, []);

  return (
    <section className="services-section" aria-label="Customer Services">
      <div className="container">
        <div className="services-grid">
          {features.map((service, index) => {
            const IconComponent = IconMap[service.icon] || Leaf;
            return (
              <div key={index} className="service-column">
                <IconComponent size={32} className="service-icon" />
                <div className="service-text">
                  <h3 className="service-title">{service.title}</h3>
                  <span className="service-subtitle">{service.subtitle}</span>
                </div>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default BottomFeatures;
